import CategoryList from '../container/list/CategoryList';

function CategoryListPage() {
    return <CategoryList />;
}

export default CategoryListPage;
